import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';

import AdminReferralSummary from '../../../adminReferral/AdminReferralSummary';
import BrokerSummary from '../../../brokers/BrokerSummary';
import BrokerClientSummary from '../../../brokerClients/BrokerClientSummary';

export default function ReferralsRoutes() {
    return (
        <>
            <Route
                path='/adminreferral'
                element={
                    <RequireAdmin>
                        <AdminReferralSummary />
                    </RequireAdmin>
                }
            />
            <Route
                path='/brokers'
                element={
                    <RequireAdmin>
                        <BrokerSummary />
                    </RequireAdmin>
                }
            />
            <Route
                path='/brokerclients'
                element={
                    <RequireAdmin>
                        <BrokerClientSummary />
                    </RequireAdmin>
                }
            />
        </>
    );
}
